(function () {
  'use strict';
  function compteurGravure(racine) {
    var champs = racine.querySelectorAll('.tw-eng--housse .tw-eng__input[data-tw-counter-for]');
    Array.prototype.forEach.call(champs, function (champ) {
      var sortie = document.getElementById(champ.getAttribute('data-tw-counter-for'));
      if (!sortie) return;
      var maxBase = parseInt(champ.getAttribute('maxlength') || '0', 10);
      var mod = champ.closest('.tw-eng');

      function pictoActif() {
        if (!mod) return false;
        var choisi = mod.querySelector('input[data-tw-picto]:checked');
        return !!(choisi && choisi.getAttribute('data-tw-picto'));
      }

      function maxEffectif() {
        var reduit = pictoActif() ? 2 : 0;
        return Math.max(0, maxBase - reduit);
      }

      var poser = function () {
        var max = maxEffectif();
        champ.setAttribute('maxlength', max);
        if (champ.value.length > max) {
          champ.value = champ.value.slice(0, max);
        }
        sortie.textContent = champ.value.length + ' / ' + max;
        /*
          La limite EXISTE (maxlength la tient), mais rien ne la disait : le champ
          cessait simplement d'accepter les lettres, ce qui se lit comme une panne.
          Le compteur s'allume quand elle mord. La cliente a fait retirer la mention
          permanente « 15 caracteres maximum » : on ne la remet pas, on la montre au
          seul moment ou elle sert.
        */
        if (max > 0 && champ.value.length >= max) {
          sortie.classList.add('tw-eng__count--plein');
        } else {
          sortie.classList.remove('tw-eng__count--plein');
        }
      };
      champ.addEventListener('input', poser);
      if (mod) {
        Array.prototype.forEach.call(mod.querySelectorAll('input[data-tw-picto]'), function (radio) {
          radio.addEventListener('change', poser);
        });
      }
      poser();
    });
  }

  function fermerGravure(racine) {
    Array.prototype.forEach.call(racine.querySelectorAll('.tw-eng--housse [data-tw-eng-close]'), function (b) {
      var pli = b.closest('details');
      if (!pli) return;
      var titre = pli.querySelector('[data-tw-eng-titre]');
      var champ = pli.querySelector('.tw-eng__input');
      if (!titre) return;
      // Deux libelles : le repli par defaut porte le prix, le repli REMPLI porte le
      // texte grave. « Graver mon baton : +8,00 € : Emma » a deux fois deux points
      // et ne se lit pas : le prix cede sa place au prenom.
      var base = titre.getAttribute('data-tw-eng-titre') || titre.textContent.trim();
      var nom = titre.getAttribute('data-tw-eng-nom') || base;

      /*
        « Le truc se ferme et c'est tout » : rien ne disait que la gravure etait
        prise. Le titre replie porte donc le texte grave, « Graver mon baton :
        Emma ». Il se remet a son libelle des que le champ est vide : un titre
        qui annoncerait un prenom efface mentirait sur ce qui part en commande.
      */
      var poser = function () {
        var t = champ ? champ.value.trim() : '';
        if (t) {
          var choix = [t];
          var picto = pli.querySelector('input[data-tw-picto]:checked');
          if (picto && picto.value) choix.push((picto.getAttribute('data-tw-label') || picto.value) + ' ' + picto.getAttribute('data-tw-picto'));
          Array.prototype.forEach.call(pli.querySelectorAll('input[data-tw-hex]:checked, input[data-tw-rend]:checked'), function (radio) {
            if (radio.value) choix.push(radio.getAttribute('data-tw-label') || radio.value);
          });
          titre.textContent = nom + ' : ' + choix.join(' · ');
          pli.classList.add('tw-eng--rempli');
        } else {
          titre.textContent = base;
          pli.classList.remove('tw-eng--rempli');
        }
      };

      if (champ) champ.addEventListener('input', poser);
      pli.addEventListener('change', poser);
      b.addEventListener('click', function () {
        poser();
        pli.open = false;
        pli.scrollIntoView({ block: 'nearest' });
      });
      poser();
    });
  }

  function apercuGravure(racine) {
    var modules = racine.querySelectorAll('.tw-eng--housse');
    Array.prototype.forEach.call(modules, function (mod) {
      var champ = mod.querySelector('.tw-eng__input');
      var sortie = mod.querySelector('[data-tw-eng-out]');
      if (!champ || !sortie) return;

      var attente = sortie.getAttribute('data-tw-vide') || '';
      var tailleMax = 26;

      function rendu() {
        var choisi = mod.querySelector('input[data-tw-rend]:checked');
        return choisi ? (choisi.getAttribute('data-tw-rend') || '') : '';
      }

      function picto() {
        var choisi = mod.querySelector('input[data-tw-picto]:checked');
        return choisi ? (choisi.getAttribute('data-tw-picto') || '') : '';
      }

      function caler() {
        var tige = sortie.parentElement;
        if (!tige) return;
        var large = tige.clientWidth - 84;
        // Pli ferme : la mesure ne veut rien dire, on ne cale pas dessus.
        if (large <= 0) return;
        sortie.style.fontSize = tailleMax + 'px';
        var taille = tailleMax;
        var garde = 0;
        while (sortie.scrollWidth > large && taille > 13 && garde < 40) {
          taille -= 1;
          sortie.style.fontSize = taille + 'px';
          garde += 1;
        }
      }

      function poser() {
        var texte = champ.value.replace(/\s+/g, ' ').trim();
        var signe = picto();
        var vide = texte === '';

        sortie.textContent = vide ? attente : (signe ? texte + ' ' + signe : texte);
        sortie.classList.toggle('tw-eng__grav--vide', vide);

        var quel = rendu();
        sortie.classList.remove('tw-eng__grav--script', 'tw-eng__grav--caps', 'tw-eng__grav--pirates', 'tw-eng__grav--varsity');
        if (quel) sortie.classList.add('tw-eng__grav--' + quel);

        // Sur du tissu, la pastille choisie est un FIL : c'est elle qui donne sa
        // couleur a la broderie. Sur du metal, il n'y a pas de pastille, et la
        // gravure garde la teinte creusee de la feuille de style.
        var pastille = mod.querySelector('input[data-tw-hex]:checked');
        var metal = pastille ? pastille.getAttribute('data-tw-metal') : '';
        sortie.classList.remove('tw-eng__grav--metal-or', 'tw-eng__grav--metal-argent');
        if (metal === 'or' || metal === 'argent') {
          // Un fil "or" ou "argent" se rend par un degrade (classe CSS), pas une
          // teinte plate : la couleur inline serait plus specifique et l'ecraserait.
          sortie.style.color = '';
          sortie.classList.add('tw-eng__grav--metal-' + metal);
        } else {
          sortie.style.color = pastille ? pastille.getAttribute('data-tw-hex') : '';
        }

        caler();
      }

      champ.addEventListener('input', poser);
      Array.prototype.forEach.call(
        mod.querySelectorAll('input[data-tw-rend], input[data-tw-picto], input[data-tw-hex]'),
        function (radio) { radio.addEventListener('change', poser); }
      );

      // A l'ouverture du pli, la tige a enfin une largeur : c'est la qu'on cale.
      if (mod.tagName === 'DETAILS') {
        mod.addEventListener('toggle', function () { if (mod.open) poser(); });
      }
      window.addEventListener('resize', caler);

      poser();
    });
  }

  function gravureVersApp(racine) {
    var section = racine.querySelector('.tw-refonte');
    if (!section) return;
    var mod = section.querySelector('.tw-eng--housse');
    var mien = mod && mod.querySelector('.tw-eng__input');
    if (!mien) return;

    /*
      LA CASE DE L'APPLICATION N'EXISTE PAS ENCORE QUAND CE CODE TOURNE.

      Mesure du 01/09/2026 sur ba-stpro9 : DOMContentLoaded a 121 ms, la case
      « pplraddprice » injectee a 823 ms. La version precedente la cherchait UNE
      fois, ne la trouvait pas, et sortait sans jamais revenir : la gravure partait
      donc a zero euro, sur tous les produits, tout le temps. Rien dans la console,
      rien de visible a l'ecran, et le defaut disparaissait des qu'on rechargeait
      assez lentement pour que l'application arrive la premiere.

      On l'attend donc, et on ne la garde jamais en reference : l'application
      reconstruit son bloc au changement de variante.
    */
    var caseApp = function () {
      return document.querySelector('input.pplraddprice[name^="properties["]');
    };

    var champApp = function () {
      return document.querySelector('.product-personalizer input.pplr_text[name^="properties["]')
          || document.querySelector('input.pplr_text[name^="properties["]');
    };

    var poser = function () {
      var c = caseApp();
      if (!c) return;
      var t = mien.value.trim();
      var veut = t.length > 0;
      if (c.checked !== veut) c.click();
      // Le champ de l'application n'existe qu'une fois la case cochee : on le
      // rappelle a chaque passage plutot que de le garder en reference.
      var z = champApp();
      if (z && z.value !== t) {
        z.value = t;
        z.dispatchEvent(new Event('input', { bubbles: true }));
        z.dispatchEvent(new Event('change', { bubbles: true }));
        z.dispatchEvent(new Event('keyup', { bubbles: true }));
      }
      var style = mod.querySelector('input[data-tw-rend]:checked');
      if (style) {
        Array.prototype.forEach.call(section.querySelectorAll('.pplr-font-select .pplr-selecter-item[data-name]'), function (option) {
          if (option.getAttribute('data-name') === style.value && !option.classList.contains('selected-font')) option.click();
        });
      }
      var fil = mod.querySelector('input[data-tw-hex]:checked');
      var couleur = section.querySelector('input.pplrjscolor[name^="properties["]');
      if (fil && couleur && couleur.value !== fil.value) {
        couleur.value = fil.value;
        couleur.dispatchEvent(new Event('input', { bubbles: true }));
        couleur.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    var arme = false;
    var armer = function () {
      if (arme || !caseApp()) return arme;
      arme = true;
      // Notre propre propriete est retiree du formulaire SEULEMENT ici : si
      // l'application n'est pas armee sur ce produit, elle reste, et le texte
      // grave part quand meme en propriete de ligne plutot que d'etre perdu.
      mien.removeAttribute('name');
      mien.addEventListener('input', poser);
      mien.addEventListener('change', poser);
      mod.addEventListener('change', poser);
      var valider = mod.querySelector('[data-tw-eng-close]');
      if (valider) valider.addEventListener('click', function () { setTimeout(poser, 60); });
      poser();
      return true;
    };

    if (armer()) return;

    var obs = new MutationObserver(function () {
      if (armer()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // L'application n'est pas installee sur tous les produits : on cesse
    // d'observer plutot que de surveiller la page jusqu'a la fin de la visite.
    setTimeout(function () { if (!arme) obs.disconnect(); }, 20000);
  }

  function proprietesGravure(racine) {
    Array.prototype.forEach.call(racine.querySelectorAll('.tw-refonte .tw-eng--housse'), function (mod) {
      var section = mod.closest('.tw-refonte');
      var form = section && section.querySelector('form.product-purchase-form');
      var id = form && form.getAttribute('id');
      if (!id) return;
      var texte = mod.querySelector('.tw-eng__input');
      var poser = function () {
        Array.prototype.forEach.call(mod.querySelectorAll('input[name^="properties["]'), function (champ) {
          if (texte && texte.value.trim()) champ.setAttribute('form', id);
          else champ.removeAttribute('form');
        });
      };
      mod.addEventListener('input', poser);
      mod.addEventListener('change', poser);
      form.addEventListener('submit', poser, true);
      poser();
    });
  }
  function demarrer(racine) {
    compteurGravure(racine);
    apercuGravure(racine);
    proprietesGravure(racine);
    gravureVersApp(racine);
    fermerGravure(racine);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
